import { formatCount } from '@/shared/lib';

const MINUS = '−';

/**
 * 980, 12.3k, 362k, 8.5M: counts that fit the menu, chart columns and bars. The unit is chosen after
 * rounding (99,950 → "100k", 999,500 → "1.0M", never "100.0k" or "1000k"); negative counts take a
 * "−" and a count that rounds to 0 has no sign.
 */
export function compactCount(value: number): string {
  const a = Math.abs(value);
  // Same unit rule as shared/lib/format.ts (fmt.eur): round to the shown digits, then pick the unit.
  const text =
    Math.round(a / 1e3) >= 1000
      ? `${(a / 1e6).toFixed(1)}M`
      : Math.round(a / 100) >= 1000
        ? `${Math.round(a / 1e3)}k`
        : Math.round(a) >= 1e4
          ? `${(a / 1e3).toFixed(1)}k`
          : formatCount(a);
  return value < 0 && text !== '0' ? `${MINUS}${text}` : text;
}

/** "12,345", "≈ 8,500,000" (from table metadata), "…" while loading, "—" when it failed. */
export const countText = ({
  count,
  estimate,
  failed,
}: {
  count: number | undefined;
  estimate: boolean;
  failed?: boolean;
}) => (failed ? '—' : count === undefined ? '…' : `${estimate ? '≈ ' : ''}${formatCount(count)}`);
